import { useMutation } from '@apollo/client/react'
import { message } from 'antd'
import { ReportNatifExtractionErrorsDocument } from '~app/graph/generated/graphql'
import i18n from '~app/i18n/i18n'

/**
 * Custom hook for setting up the API call to report document extraction errors to Natif
 */
const useReportNatifDocumentExtractionErrors = ({
  documentId,
}: {
  documentId: string
}): {
  reportNatifDocumentExtractionErrors: () => Promise<void>
  loading: boolean
} => {
  const [reportNatifExtractionErrorsMutation, { loading }] = useMutation(
    ReportNatifExtractionErrorsDocument
  )

  const reportNatifDocumentExtractionErrors = async () => {
    try {
      await reportNatifExtractionErrorsMutation({
        variables: {
          data: {
            errorFields: {
              documentExtraction: true,
            },
          },
          where: {
            id: documentId,
          },
        },
      })
      message.success(i18n.t('natifErrorReport.successMessage'), 2.5)
    } catch (error) {
      message.error(i18n.t('natifErrorReport.errorMessage', { error }), 5)
      console.error(error)
    }
  }

  return {
    reportNatifDocumentExtractionErrors,
    loading,
  }
}

export { useReportNatifDocumentExtractionErrors }
